import React from 'react'
import styled from 'styled-components'

// styled
const StyledPlane = styled.div`
  position: relative;
  width: 100%;
  height: 220px;
  .plane {
    position: absolute;
    z-index: 1;
    left: 206px;
    top: 80px;
    animation: move 3s linear infinite;
    @media screen and (max-width: 800px) {
      top: 60px;
      left: 50%;
    }
    .wingRight {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 22.5px solid transparent;
      border-right: 12.5px solid transparent;
      border-bottom: 115px solid var(--white);
      transform: rotate(61deg);
      z-index: 4;
    }
    .bottom {
      position: relative;
      width: 0;
      height: 0;
      border-left: 12.5px solid transparent;
      border-right: 12.5px solid transparent;
      border-bottom: 25.5px solid var(--grey-hover);
      top: 71px;
      transform: rotate(-5deg);
      left: -52.5px;
      z-index: 3;
    }
    .top {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 30px solid var(--text);
      top: 65px;
      transform: rotate(5deg);
      left: -60px;
      z-index: 1;
    }
    .middle {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 135px solid var(--text);
      top: -13.5px;
      transform: rotate(72deg);
      left: -7.5px;
      z-index: 2;
    }
    .wingLeft {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 25px solid transparent;
      border-bottom: 135px solid var(--white);
      transform: rotate(78deg) skewY(-35deg);
      left: -18.5px;
      z-index: 3;
      top: -30px;
    }
  }
  .clouds {
    position: absolute;
    top: 50px;
    left: 100px;
    .cloudOne,
    .cloudTwo,
    .cloudThree {
      position: absolute;
      width: 50px;
      height: 25px;
      background-color: var(--grey-hover);
      border-radius: 100px 100px 0 0;
    }
    .cloudOne {
      top: 0;
      left: 0;
      animation: cloud 10s linear infinite reverse;
    }
    .cloudTwo {
      top: 50px;
      left: 280px;
      animation: cloud 9.2s linear infinite reverse;
    }
    .cloudThree {
      top: 240px;
      left: 130px;
      animation: cloud 8.5s linear infinite reverse;
    }
    .cloudOne:before,
    .cloudTwo:before,
    .cloudThree:before {
      content: '';
      position: absolute;
      width: 25px;
      height: 12.5px;
      background-color: var(--grey-hover);
      border-radius: 100px 100px 0 0;
      left: -20px;
      top: 12.5px;
      box-shadow: 65px 0 var(--grey-hover);
    }
  }
  @keyframes move {
    0% {
      transform: translateY(0) rotateX(0);
    }
    25% {
      transform: translateY(-30px) rotateX(40deg);
    }
    50% {
      transform: rotateX(0) translateY(0);
    }
    75% {
      transform: rotateX(-40deg) translateY(30px);
    }
    100% {
      transform: rotateX(0) translateY(0);
    }
  }
  @keyframes cloud {
    from {
      left: -1650px;
    }
    to {
      left: 2200px;
    }
  }
`

const PaperPlane = () => {
  return (
    <StyledPlane>
      <div className="plane">
        <div className="wingRight"></div>
        <div className="wingLeft"></div>
        <div className="bottom"></div>
        <div className="top"></div>
        <div className="middle"></div>
      </div>
      <div className="clouds">
        <div className="cloudOne"></div>
        <div className="cloudTwo"></div>
        <div className="cloudThree"></div>
      </div>
    </StyledPlane>
  )
}

export default PaperPlane
